module.exports = __webpack_public_path__ + "127d8d8ba509c8206b89d09bba54ce18.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-25.png
// module id = 1795
// module chunks = 0